import {
  assitant,
  ecom1,
  ecom10,
  ecom2,
  ecom3,
  ecom4,
  ecom5,
  ecom6,
  ecom7,
  ecom8,
  ecom9,
  ecommerce,
  finanseer1,
  finanseer2,
  fitness1,
  fitness2,
  fitness3,
  fitness4,
  fiverr,
  fiverr1,
  fiverr2,
  fiverr3,
  fiverr4,
  fiverr5,
  fiverr6,
  fiverr7,
  jobsearch1,
  jobsearch2,
  jobsearch3,
  jobsearch4,
  jobsearch5,
  jobsearch6,
  jobsearch7,
  metaversus,
  prompt,
} from "../../assets/index";

export const data = [
  {
    id: 1,
    name: "Liverr(Full Stack Fiverr Clone)",
    desc: "The Fiverr clone project offers buyer and seller accounts, enabling sellers to create gigs and buyers to make purchases using Stripe payment. After purchasing a gig, buyers can leave reviews with 5-star ratings. The platform features a page to explore all sellers' gigs, and a chat section allows buyers and sellers to communicate after a gig purchase.",
    img: [
      fiverr,
      fiverr1,
      fiverr2,
      fiverr3,
      fiverr4,
      fiverr5,
      fiverr6,
      fiverr7,
    ],
    gitUrl: "https://github.com/Afrin127329/full-stack-fiverr-app",
    liveLink: "https://full-stack-fiverr-app.vercel.app/",
  },
  {
    id: 2,
    name: "Ecommerce website(Full Stack)",
    desc: "The ecommerce project offers user and admin registration with separate dashboards. Users can add items to their cart and make payments through Stripe. After successful payment, the admin can mark orders as completed or processing. The admin has full control over creating, deleting, and updating categories and products. The homepage includes filters for easy product navigation. (Admin Credentials: email: admin@gmail.com and password: admin",
    img: [
      ecommerce,
      ecom1,
      ecom2,
      ecom3,
      ecom4,
      ecom5,
      ecom6,
      ecom7,
      ecom8,
      ecom9,
      ecom10,
    ],
    gitUrl: "https://github.com/Afrin127329/full-stack-ecommerce",
    liveLink: "https://full-stack-ecommerce-at53.onrender.com/",
  },
  {
    id: 3,
    name: "Promptopia (Full Stack Text Summerizer with Next 13.4)",
    desc: "Promptopia is an exceptional project that utilizes OpenAI's chatbot to offer an incredible text summarization feature. Users can summarize texts and share them on the community page. With Google sign-up integration, the web app is built using the latest Next.js 13.4 app directory and incorporates a serverless routing system for optimal performance.",
    img: [prompt],
    gitUrl: "https://github.com/Afrin127329/full-stack-next13-ai-app",
    liveLink: "https://full-stack-next13-ai-app.vercel.app/",
  },
  {
    id: 4,
    name: "Email Assistant(Chrome Extension)",
    desc: "The innovative Chrome extension boasts a remarkable feature that automates email composition with a single click within the mailbox. Leveraging the power of OpenAI's chatbot, it intelligently completes email lines, saving users valuable time and effort. This seamless integration of the chatbot enhances email productivity and streamlines communication workflows.",
    img: [assitant],
    gitUrl: "https://github.com/Afrin127329/email-assistant",
    liveLink: "https://www.youtube.com/watch?v=waHuG-LUtMQ",
  },
  {
    id: 5,
    name: "Finanseer(Admin Dashboard)",
    desc: "Introducing our finance management platform, built with Redux, TypeScript, Material UI, Express, and machine learning. Get a clear view of your yearly income and expenses on an intuitive dashboard for easy price and cost comparisons. Keep tabs on product performance to make smart inventory and pricing decisions. Identify cost-saving opportunities with a breakdown of operational and non-operational expenses. Plus, harness the power of machine learning to predict future revenue.",
    img: [finanseer1, finanseer2],
    gitUrl: "https://github.com/Afrin127329/admin-dashboard",
    liveLink: "https://admin-dashboard-t1.vercel.app/",
  },
  {
    id: 6,
    name: "Your Fitness Solution",
    desc: "Introducing a sleek and efficient fitness application designed with stunning styles powered by Tailwind CSS. This single-page wonder is crafted using React in the front end, leveraging the power of TypeScript for enhanced reliability and development speed. With this user-friendly interface, you can effortlessly submit your fitness goals and preferences to book a personalized coaching call.",
    img: [fitness1, fitness2, fitness3, fitness4],
    gitUrl: "https://github.com/Afrin127329/fitness-app",
    liveLink: "https://fitness-app-teal-six.vercel.app/",
  },
  {
    id: 7,
    name: "Job Search Mobile Application(React Native)",
    desc: "A Job search application that includes functionalities like Search job directly from any location, See popular and suggested jobs, Filter by job types, apply directly in the browser, Specialty of this application is it shows jobs from different portals like Glassdoor, Indeed, Linkedin etc. Tech Stack: React Native, Typescript, JSearch API from Rapid API, React Native Stylesheet",
    img: [
      jobsearch1,
      jobsearch2,
      jobsearch3,
      jobsearch4,
      jobsearch5,
      jobsearch6,
      jobsearch7,
    ],
    gitUrl: "https://github.com/Afrin127329/job-search-app",
    liveLink: "https://www.youtube.com/watch?v=q5FmxX6v460",
  },
  // {
  //     id: 7,
  //     name: "Gericth Restaurent(Single Page)",
  //     desc: "A modern UI/UX (figma) design converted into a live website with Reactjs, following famous BEM methodology in CSS.",
  //     img: [gericth2],
  //     gitUrl: "https://github.com/Afrin127329/frontend-gericht-restaurent",
  //     liveLink: "https://afrins-gericht-restaurent.netlify.app/"
  // },
  {
    id: 8,
    name: "Metaversus",
    desc: "The website is a single page Application that is built with Next13, Reactjs, TailwindCSS and most importantly Framer Motion for amazing Animation.",
    img: [metaversus],
    gitUrl: "https://github.com/Afrin127329/metaversus-nextjs",
    liveLink: "https://metaversusbyafrin.netlify.app/",
  },
];
